export default __webpack_public_path__ + "static/media/bxs_user-detail.b1f712cb.svg";